const getNoOptionsText = (searchLength: number) => {
  switch (searchLength) {
    case 0:
      return "Zacznij wpisywanie";
    case 1:
    case 2:
      return "Min. 3 znaki";
    default:
      return "Brak wyników";
  }
};

export default getNoOptionsText;
